import $ from '../static/js/lib/jquery.min.js'
import Modernizr from '../static/js/lib/modernizr-custom.min-9.js'
import Rellax from '../static/js/lib/rellax.min.js'
import { ripples } from '../static/js/lib/jquery.ripples-min.js'
import { UI } from '../static/js/helpers/UI.js'
import { getCookie, setCookie, isValidEmail, getUrlParameter} from '../static/js/helpers/utils.js'
import CartItem from './cart/cart-item.js'
import UserCart from './cart/user-cart.js'
import BackendAPI from '../static/js/helpers/API.js'
import { checkIOSPowerSavingMode } from './checkout/CommonUtils.js'

const mainUI = {
  body: document.querySelector("body"),
  primaryNav: document.querySelector("header"),
  primaryMenu: document.querySelector("#productMenu"),
  productJumpLinks: document.querySelectorAll(".product-nav-wrapper .jump-links-dropdown"),
  customSelect: document.querySelectorAll(".product-filters"),
  subscribeBtn: document.querySelector('#subscribeForm input[type="submit"]'),
  subscribeError: document.querySelector('#subscribeForm .subscribe-error'),
  subscribeBtnModal: document.querySelector('#subscribeFormModal input[type="submit"]'),
  subscribeErrorModal: document.querySelector('#subscribeFormModal .subscribe-error'),
  joinFomForm: document.querySelector('#joinFom'),
  joinFomBtn: document.querySelector('#joinFom input[type="submit"]'),
  joinFomStatus: document.querySelector('.joinfom-form-wrapper #formStatus'),
  joinFomMessage: document.querySelector('.joinfom-form-wrapper #formStatus p'),
  floaterBar: document.querySelector('#floaterBar'),
  washedHero: document.querySelector('#washed .category-hero .block-wrapper .picture'),
  navThumbnails: document.querySelectorAll('#productMenu .core-products .thumbnail img')
}

var lastScrollTop = 0;
var API = new BackendAPI();
API.setBaseUrl(host);
//UI Functions ()

var forEach = function (arr, callback) { //Common function for an array of elements
  Array.prototype.forEach.call(arr, callback);
}

var seamlessPrimaryNav = function () { //Seamless Header
  mainUI.primaryNav.classList.add('inverse');
}
var solidPrimaryNav = function () { //Regular Header
  mainUI.primaryNav.classList.remove('inverse');
}
var hidePrimaryNav = function () { //show Primary Navigation
  mainUI.primaryNav.classList.add('out-of-sight-y');
  var productNav = document.querySelector("#productNav");
  if (mainUI.body.classList.contains('product-page') && productNav && productNav.classList.contains('fixed-block')) {
    productNav.classList.remove('shift');
  }
}
var showPrimaryNav = function () { //hide Primary Navigation
  mainUI.primaryNav.classList.remove('out-of-sight-y');
  var productNav = document.querySelector("#productNav");
  if (mainUI.body.classList.contains('product-page') && productNav && productNav.classList.contains('fixed-block')) {
    productNav.classList.add('shift');
  }
}
var stickPrimaryNav = function () { //Primary Navigation behaviour
  var scrollTop = window.scrollY;
  var productcarousalHeight = (UI.find('.product .carousal')) ? UI.find('.product .carousal').offsetHeight : 10;
  var productCatHero = (UI.find('.category-index-special .hero')) ? UI.find('.category-index-special .hero').offsetHeight : 10;
  var productIndexHeight = (UI.find('.product-index main')) ? UI.find('.product-index main').offsetHeight : 0;
  var productHeroHeight = (UI.find('.product #hero')) ? UI.find('.product #hero').offsetHeight : 0;
  var compareHero = (UI.find('.compare-tees .compare-hero')) ? UI.find('.compare-tees .compare-hero').offsetHeight : 10;
  if (mainUI.body.classList.contains('product-index') && scrollTop < productIndexHeight && !mainUI.body.classList.contains('opaque-header')|| 
      mainUI.body.classList.contains('product-page') && scrollTop < productHeroHeight ||
      mainUI.body.classList.contains('product-variant') && scrollTop < productcarousalHeight ||
      mainUI.body.classList.contains('category-index-special') && scrollTop < productCatHero ||
      mainUI.body.classList.contains('compare-tees') && scrollTop < compareHero ||
      mainUI.body.classList.contains('splash-page')
     ) {
    seamlessPrimaryNav();
  } else {
    solidPrimaryNav();
  }
  if (scrollTop > lastScrollTop) {
    if (window.scrollY > 5 && UI.find('#cartMenu') && UI.find('#cartMenu').classList.contains('out-of-sight')) {
      hidePrimaryNav();
      if (mainUI.floaterBar){
        hideFloaterBar();
      }
    }
  } else {
    showPrimaryNav();
    if (mainUI.floaterBar){
      showFloaterBar();
    }
  }
  lastScrollTop = scrollTop;
}
var showDropdownMenu = function () { //Product Dropdown
  UI.hideModals();
  solidPrimaryNav();
  document.querySelector('body').style.overflow = 'hidden';
  document.querySelector('.dropdown-overlay').classList.remove('out-of-sight');
  if (mainUI.primaryMenu){
    mainUI.primaryMenu.classList.remove('out-of-sight');
  }
  UI.find('header #primaryMenuBtn').classList.add('selected');
  mainUI.navThumbnails = document.querySelectorAll('#productMenu .core-products .thumbnail img');
  mainUI.navThumbnails.forEach(thumbnail => {
    const videoUrl = thumbnail.getAttribute('data-thumbnail-video-url');
    if (videoUrl) {
      // Check if there's already a video element in the parentNode
      let existingVideo = thumbnail.parentNode.querySelector('video');
      if (!existingVideo) {
        const videoElement = document.createElement('video');
        videoElement.setAttribute('src', videoUrl);
        videoElement.setAttribute('autoplay', '');
        videoElement.setAttribute('loop', '');
        videoElement.setAttribute('muted', '');
        videoElement.setAttribute('playsinline', '');
        videoElement.setAttribute('poster', thumbnail.src);
        thumbnail.parentNode.insertBefore(videoElement, thumbnail.nextSibling);
      }
    }
  });
}
var hideDropdownMenu = function () {
  stickPrimaryNav();
  document.querySelector('body').style.overflow = 'auto';
  document.querySelector('.dropdown-overlay').classList.add('out-of-sight');
  if (mainUI.primaryMenu){
    mainUI.primaryMenu.classList.add('out-of-sight');
  }
  var primaryMenuBtn = UI.find('header #primaryMenuBtn');
  if (primaryMenuBtn) {
    primaryMenuBtn.classList.remove('selected');
  }
}
var toggleDropdownMenu = function () {
  if (mainUI.primaryMenu && mainUI.primaryMenu.classList.contains('out-of-sight')) {
    showDropdownMenu();
  } else {
    hideDropdownMenu();
  }
}

var initRellax = function () {
  if (typeof rellax !== 'undefined') {
    try {
      rellax.destroy();
    } catch (error) { }
  }
  if (typeof Rellax === 'function' && document.querySelector(".rellax")) {
    var rellax = new Rellax('.rellax');
  }
}

//Common function to set Progress Bars
function setProgressBars() {
  var progressBars = document.querySelectorAll(".progress-bar");
  if (progressBars) {
    for (var i = 0; i < progressBars.length; i++) {
      var progressBar = progressBars[i];
      var total = parseInt(progressBar.getAttribute("data-total"));
      var left = parseInt(progressBar.getAttribute("data-left"));
      var perc;
      if (isNaN(total) || isNaN(left)) {
        perc = " ";
      } else {
        perc = ((left * 100) / total).toFixed(2);
      }
      var progressFiller = progressBar.querySelector('.progress');
      progressFiller.style.right = perc + '%';
    }
  }
}
function showSubscribeFormWomen() { //Jumps to the common footer subscribe block. To be called on any and every <a class="jump-to-subscribe"> 
  var commonSubscribe = document.querySelector(".common-subscribe");
  var commonSubscribeInput = document.querySelector(".common-subscribe #subscribeForm input[type=email]")
  var womenSelector = document.querySelector(".common-subscribe #subscribeForm .styles")

  if (commonSubscribe) {
    commonSubscribe.scrollIntoView();
    // womenSelector.value = "women"
    setTimeout(function(){
      if(commonSubscribeInput){ 
        womenSelector.value = "women"
        commonSubscribeInput.focus();
      }
    }, 500);
  }
}

function showSubscribeForm() { //Jumps to the common footer subscribe block. To be called on any and every <a class="jump-to-subscribe"> 
  var commonSubscribe = document.querySelector(".common-subscribe");
  var commonSubscribeInput = document.querySelector(".common-subscribe #subscribeForm input[type=email]")
  if (commonSubscribe ) {
    commonSubscribe.scrollIntoView();
    setTimeout(function(){
      if(commonSubscribeInput){ 
        commonSubscribeInput.focus();
      }
    }, 500);
  }
}

function subscribeToEmails(email, styles) {
    const url = '/customer/add';
    var data = {email, styles};
    API.post(url, data)
      .then(data => {
        if(data.status == 'success'){
          mainUI.subscribeBtn.value = '👍';
          gtag('event', 'Subscribe', {
            'allow_custom_scripts': true,
            'send_to': 'G-S6C1WKTJNT',
            'event_category': 'Pre-sale Email subscription',
            'event_label': 'March 2023 presale email signups'
          });
        }
        else{
          if(typeof(debugFlag) != 'undefined' && debugFlag){
            mainUI.subscribeError.style.display = 'block';
            console.log(data);
          }
        }
      }).catch(error => {
        if(typeof(debugFlag) != 'undefined' && debugFlag){
          console.log(error);
        }
    });
}
function subscribeToEmailsModal(email, styles) {
    const url = '/customer/add';
    var data = {email, styles};
    API.post(url, data)
      .then(data => {
        if(data.status == 'success'){
          mainUI.subscribeBtnModal.value = '👍';
        }
        else{
          if(typeof(debugFlag) != 'undefined' && debugFlag){
            mainUI.subscribeErrorModal.style.display = 'block';
            console.log(data);
          }
        }
      }).catch(error => {
        if(typeof(debugFlag) != 'undefined' && debugFlag){
          console.log(error);
        }
    });
}

function joinFomRequest() {
  let form = UI.find('#joinFom');
  let url = form.getAttribute('data-url');
  API.form_post(url, new FormData(form)).then(data => {
      if(data.success == true){
        form.reset();
        mainUI.joinFomMessage.textContent = "Nice! We'll get in touch";
        mainUI.joinFomStatus.style.display = 'block';
        mainUI.joinFomBtn.style.display = 'none';
      }
      else {
        if (typeof(debugFlag) != 'undefined' && debugFlag) {
          mainUI.joinFomMessage.textContent = 'Something went wrong';
          mainUI.joinFomStatus.style.display = 'block';
          console.log(data);
        }
      }
    }).catch(error => {
      if (typeof(debugFlag) != 'undefined' && debugFlag) {
        mainUI.joinFomMessage.textContent = 'Something went wrong';
        mainUI.joinFomStatus.style.display = 'block';
        console.log(error);
      }
  });
}

//Common function to post standalone forms
function websiteFormRequest(el, btntext) {
  let form = el;
  let url = form.getAttribute('data-url');
  let websiteMessageWrapper= form.closest('.website-form-wrapper').querySelector('#formStatus');
  let websiteMessage = websiteMessageWrapper.querySelector('p');
  let submitButton = form.querySelector('#formSubmitBtn');
  API.form_post(url, new FormData(form)).then(data => {
      if(data.success == true){
        form.reset();
        submitButton.value = btntext;
        websiteMessage.textContent = "Great! See you there 😊";
        websiteMessageWrapper.style.display = 'block';

        if (typeof gtag !== 'undefined'){
          // GA4 event tracking
          gtag('event', 'Subscribe', {
              'allow_custom_scripts': true,
              'send_to': 'G-S6C1WKTJNT',
              'event_category': 'Pre-sale Email subscription',
              'event_label': 'March presale email signups'
          });
        
          // Google Ads conversion tracking for Sign ups
          gtag('event', 'conversion', {
              'send_to': 'AW-864049095/s86mCMuc0KcaEMevgZwD',
              'value': 1.0,
              'currency': 'INR'
          });
        }
      }
      else {
        if (typeof(debugFlag) != 'undefined' && debugFlag) {
          submitButton.value = btntext;
          websiteMessage.textContent = 'Something went wrong';
          websiteMessageWrapper.style.display = 'block';
          console.log(data);
        }
      }
    }).catch(error => {
      if (typeof(debugFlag) != 'undefined' && debugFlag) {
        submitButton.value = btntext;
        websiteMessage.textContent = 'Something went wrong';
        websiteMessageWrapper.style.display = 'block';
        console.log(error);
      }
  });
}
//International Request 
function showFieldError(field, error) {
  error.show
  errormessage.text = error
}

/**
 * Sets the tab of the sidebar to show products acording to the style
 * @param {string} style style/gender of the current user
 */

function resetNavTabLink() {
  let tabLinks = document.querySelectorAll('#styleMenu .tab-link');
  let tabContents = document.querySelectorAll('#productMenu .tab-content');
  if ( tabLinks ){
    for (const tabLink of tabLinks){
      tabLink.classList.remove('selected');
    };
  } 
  if ( tabContents ){
    for (const tabContent of tabContents){
      tabContent.classList.remove('selected');
    };
  } 
}

function changeNavTabLink(navState) {
  let styleMenu = UI.find('#styleMenu');
  if (styleMenu){
    if (navState == 'women') {
      resetNavTabLink();
      let womenTabLink = UI.find("#tab-link-women");
      if (womenTabLink){
        womenTabLink.classList.add("selected");
      }
      let womensideBar = UI.find("#women-sidebar");
      if(womensideBar){
        womensideBar.classList.add("selected");
      }

    } 
    if (navState == 'men') {
      resetNavTabLink();
      let menTabLink = UI.find("#tab-link-men");
      if(menTabLink){
          menTabLink.classList.add("selected");
      }
      let mensideBar = UI.find("#men-sidebar");
      if(mensideBar){
        mensideBar.classList.add("selected");
      }
    } 
    if (navState == 'fom') {
      resetNavTabLink();
      let fomTabLink = UI.find("#tab-link-fom");
      if(fomTabLink){
          fomTabLink.classList.add("selected");
      }
      let fomsideBar = UI.find("#men-sidebar");
      if(fomsideBar){
        fomsideBar.classList.add("selected");
      }
    }
  }
}

function collectionNavLayout() {
  var collectionsNav = document.querySelector('#productMenu .product-collections');
  var collectionsCount = document.querySelectorAll('#productMenu .product-collections .product-collection').length;
  if (collectionsNav){
    if (collectionsCount%2 == 0){
      collectionsNav.classList.add('even')
    } else {
      collectionsNav.classList.add('odd') 
    }
  }
}

//Animate Global Live Ticker
function globalLiveView (n) {
  var currentViews = n;
  var lastViewsDiv = document.querySelector('#visitorsCount');
  if (!lastViewsDiv){
    return;
  }
  var lastViews = parseInt(lastViewsDiv.textContent, 10) || 1;
  if ( currentViews > lastViews ){ // Check if views are more and animate counter
    $(lastViewsDiv).prop('Counter', lastViews).animate({
      Counter: currentViews
    }, {
      duration: 5000,
      easing: 'swing',
      step: function(now) {
          $(this).text(Math.ceil(now));
      }
    }); 
  } else { // Do not animate if less
    lastViewsDiv.textContent = currentViews;
  }
}

function realTimeCount() {
    const url = '/visitors_count';
    API.get(url)
      .then(data => {
        if(data && data.active){
          globalLiveView(data.active)
        }
      }).catch(error => {
        if(typeof(debugFlag) != 'undefined' && debugFlag){
          console.log(error);
        }
    });
}

//Get random country
function getRandomCountry() {
    var prevIndex;
    var countries = [
      "England 🏴󠁧󠁢󠁥󠁮󠁧󠁿󠁧",
      "Scotland 🏴󠁧󠁢󠁳󠁣󠁴󠁿",
      "Vietnam 🇻🇳",
      "The US 🇺🇸󠁧󠁢󠁥󠁮󠁧󠁿󠁧",
      "Uruguay 🇺🇾󠁧󠁢󠁳󠁣󠁴󠁿",
      "Ukraine 🇺🇦󠁧󠁢󠁥󠁮󠁧󠁿󠁧",
      "Thailand 🇹🇭󠁧󠁢󠁳󠁣󠁴󠁿",
      "Vietnam 🇻🇳",
      "The US 🇺🇸󠁧󠁢󠁥󠁮󠁧󠁿󠁧",
      "Uruguay 🇺🇾󠁧󠁢󠁳󠁣󠁴󠁿",
      "Uganda 🇺🇬",
      "Singapore 🇸🇬󠁧󠁢󠁥󠁮󠁧󠁿󠁧",
      "Sweden 🇸🇪",
      "Portugal 🇵🇹",
      "Poland 🇵🇱",
      "New Zealand 🇳🇿󠁧󠁢󠁳󠁣󠁴󠁿",
      "Peru 🇵🇪󠁧󠁢󠁥󠁮󠁧󠁿󠁧",
      "Nepal 🇳🇵",
      "Maldives 🇲🇻",
      "Kuwait 🇰🇼󠁧󠁢󠁥󠁮󠁧󠁿󠁧",
      "Japan 🇯🇵󠁧󠁢󠁳󠁣󠁴󠁿",
      "Italy 🇮🇹",
      "Israel 🇮🇱",
      "Indonesia 🇮🇩",
      "Greece 🇬🇷",
      "France 🇫🇷",
      "Egypt 🇪🇬",
      "Fiji 🇫🇯",
      "Denmark 🇩🇰󠁧󠁢󠁥󠁮󠁧󠁿󠁧",
      "Germany 🇩🇪",
      "Costa Rica 🇨🇷",
      "Colombia 🇨🇴",
      "Switzerland 🇨🇭",
      "Canada 🇨🇦",
      "Brazil 🇧🇷",
      "Bangladesh 🇧🇩",
      "Australia 🇦🇺",
      "Argentina 🇦🇷"
    ];
    var randomIndex = Math.floor(Math.random()*countries.length);
    if ( randomIndex != prevIndex ){
      return(countries[randomIndex])
    } else {
      randomIndex = randomIndex + 1
      return(countries[randomIndex])
    }
    prevIndex = randomIndex;
}

var showFloaterBar = function () { //Floater Bars on Index
  mainUI.floaterBar.classList.add('in-sight');
}
var hideFloaterBar = function () { //Floater Bars on Index
  mainUI.floaterBar.classList.remove('in-sight');
}

var washedRipples = function (){
  if (mainUI.washedHero){
    try {
      jQuery(mainUI.washedHero).ripples({
        resolution: 512,
        dropRadius: 20, //px
        perturbance: 0.02,
        interactive: false
      })
    }
    catch (e) {
      console.log(e)
    }
    setInterval(function() {
      var $el = jQuery(mainUI.washedHero);
      var x = Math.random() * $el.outerWidth();
      var y = Math.random() * $el.outerHeight();
      var dropRadius = 20;
      var strength = 0.02 + Math.random() * 0.02;
      $el.ripples('drop', x, y, dropRadius, strength);
    }, 1000);
  }
}

var featureReveal = function(){
  setTimeout(function(){
    UI.find('#featurePouch').classList.add('animate-in');
    UI.find('#featurePouch').classList.remove('initial');
  }, 100);
  UI.find('#featureComm').classList.add('fade-in');
}

//Events and Listeners
function attachEventListeners() {

  document.addEventListener('click', function (event) { // Hide Product Menu on clicking outside
    var isProductMenu = event.target.closest('#productMenu');
    var isProductLink = event.target.closest('#primaryMenuBtn');
    var outOfSight = mainUI && mainUI.primaryMenu && mainUI.primaryMenu.classList.contains("out-of-sight");
    var link = event.target.closest('a.show-navigation');
    if (!isProductMenu && !isProductLink && !outOfSight && !link) {
      hideDropdownMenu();
    }
  });
  
  let dropdownOverlay = UI.find('.dropdown-overlay');
  if (dropdownOverlay) {
    dropdownOverlay.addEventListener('click', function (e) {
      e.preventDefault();
      UI.hideModals();
    })
  }

  let hamburger = UI.find('header #primaryMenuBtn');
  if (hamburger) {
    UI.find('header #primaryMenuBtn').addEventListener('click', function (e) {
      e.preventDefault();
      toggleDropdownMenu();
    })
  }
  
  let subscribeBtns = UI.findAll('header #productMenu a.jump-to-subscribe');
  if(subscribeBtns){
    for (const subscribeBtn of subscribeBtns){
        subscribeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        hideDropdownMenu();
    });
    }
  }
  let subscribeBtnsWomen = UI.findAll('header #productMenu a.jump-to-subscribe-women');
  if(subscribeBtnsWomen){
    for (const subscribeBtn of subscribeBtnsWomen){
        subscribeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        hideDropdownMenu();
    });
    }
  }
  let fomsidebarlinks = UI.findAll('#fom-sidebar a.product-block');
  if(fomsidebarlinks){
    for (const fomsidebarlink of fomsidebarlinks){
        fomsidebarlink.addEventListener('click', function (e) {
        hideDropdownMenu();
    });
    }
  }
  let comingSoonLinks = UI.findAll('a.coming-soon');
  if(comingSoonLinks){
    for (const comingSoonLink of comingSoonLinks){
        comingSoonLink.addEventListener('click', function (e) {
        e.preventDefault();
        showSubscribeForm();
    });
    }
  }

  let storeSwitcher = UI.find('.store-picker select');
  if (storeSwitcher) {
    storeSwitcher.addEventListener('change', function (event) {
      let selectedSeller = event.target.selectedOptions[0];
      overrideCountry(selectedSeller.value)
      // var url = new URL(window.location.href)
      // var originUrl = url.origin + '/' + selectedSeller.value;
      // window.location.href = originUrl + url.pathname.replace('/' + seller, '');
      selectedSeller.selected = 'selected';
    });
  }

  function overrideCountry(country, falseoveride=true) {
    
    const url = '/override/country';
    API.post(url, { "country": country })
      .then(data => {
        if (data.status == 'success') {
          var url = new URL(window.location.href);
          var originUrl = url.origin + '/' + country;
          window.location.href = originUrl + url.pathname.replace('/' + store_country, '');
        }
        else {
          if (typeof (debugFlag) != 'undefined' && debugFlag) {
            console.log(data);
          }
        }
      }).catch(error => {
        if (typeof (debugFlag) != 'undefined' && debugFlag) {
          console.log(error);
        }
      });
  }
  // Attach Size change event to update products
  const sizePickers = document.querySelectorAll("size-picker");
  if (sizePickers) {
    for (const sizePicker of sizePickers) {
      sizePicker.addEventListener('sizeChange', function (event) {
        updateProductCards(event.detail.size, event.detail.style, event.detail.productType)
      });
    }
  }


  var otpInput = document.querySelector('#order-otp')
  if (otpInput){
    var otpInputButton = document.querySelector('#otp-submit-button')
    otpInput.addEventListener('keyup', (event => {
      event.preventDefault();
      let otp = event.target.value
      if(otp.length==4){
        otpInputButton.classList.remove('disabled');
      }
      else{
        otpInputButton.classList.add('disabled');
      }
    }));
  }

  var otpForm = document.querySelector("#otp-form");
  if (otpForm) {
    otpForm.addEventListener("submit", (event) => {
      event.preventDefault();
      setTimeout(function () {
          otpForm.submit();
      }, 500);
      var otpSubmitButton = document.querySelector("#otp-submit-button");
        if (otpSubmitButton) {
          otpSubmitButton.classList.add("disabled");
        }
    });
  }

  // get called after window location changed to remove the disabled class of submit button
  window.onunload = function(event) {
    var otpSubmitButton = document.querySelector("#otp-submit-button");
    if (otpSubmitButton) {
        otpSubmitButton.classList.remove("disabled");
    }
  };
  
  var otpVerifyForm = document.querySelector("#otp-verify-form");
  if (otpVerifyForm) {
    otpVerifyForm.addEventListener("submit", (event) => {
      event.preventDefault();
      setTimeout(function () {
          otpVerifyForm.submit();
      }, 500);
      var otpVerifyButton = document.querySelector("#otp-verify-button");
        if (otpVerifyButton) {
          otpVerifyButton.classList.add("disabled");
        }
    });
  }   


  // Attach Cart updated event to display cart 
  let userCart = document.querySelector('user-cart');
  if (userCart) {
    userCart.addEventListener('cartUpdated', (event => {
      showPrimaryNav();
      let items = event.detail.items;
      if (items) {
        for (const item of items) {
          let cartObj = { 'sku': item.sku, 'quantity': item.quantity };
          setProductMaxedOutStatus(cartObj);
        }
      }
    }));
  }

  // Subscribe to size picker change and update the size & sku on the product card
  var updateProductCards = async function (size, style, productType) {
    let productCards = document.querySelectorAll('product-card')
    const cartItems = document.querySelectorAll(`cart-item`);
    let url = `/shop/${productType}/${style}/${size}`
    API.get(url)
      .then(data => {
        if (!data.error) {
          data.products.forEach(product => {
            const productCard = document.querySelector(`product-card[group=${product.group}]`)
            if (productCard) {
              productCard.setAttribute("sku", product.sku);
              productCard.shippingDate = product.shipping_date;
              productCard.preorder = product.preorder;
              productCard.finalSale = product.final_sale;
              productCard.setAttribute("size", size);
              productCard.size = size;
              if (product.preorder || (product.available && !product.out_of_stock)) {
                productCard.setAttribute("available", "true");
              }
              else {
                productCard.setAttribute("available", "false");
              }

              for (const cartItem of cartItems) {
                if (cartItem.sku == productCard.sku) {
                  productCard.maxedOut = cartItem.quantity >= 9;
                  break;
                }
              }
            }
          });
        }
        else {
          // handle error here
        }
      }).catch(error => {
        // handle error here
        console.log(error);
      }).then(data => {
      })
  }

  // Subscribe to cart updates and set the product card max items status if quantity in cart has maxed out
  var setProductMaxedOutStatus = function (cartItemObj) {
    const cards = document.querySelectorAll(`product-card[sku=${cartItemObj.sku}]`)
    for (const productCard of cards) {
      productCard.maxedOut = cartItemObj.quantity >= 9;
    }
  };

  updateProductMaxedOutStatus()
  function updateProductMaxedOutStatus() {
    const cartItems = document.querySelectorAll(`cart-item`);
    for (const cartItem of cartItems) {
      const cards = document.querySelectorAll(`product-card[sku=${cartItem.sku}]`)
      for (const productCard of cards) {
        productCard.maxedOut = cartItem.quantity >= 9;
      }
    }
  }
  // Common Subscribe Form functions
  let subscribeEmail = UI.find('#subscribeForm input[type="email"]');
  let styleSelector = UI.find('#subscribeForm select.styles');
  
  if(subscribeEmail){
      subscribeEmail.addEventListener('keyup', (event => {
        event.preventDefault();
        if(isValidEmail(event.target.value)){
          mainUI.subscribeBtn.classList.remove('disabled');
        }
        else{
          mainUI.subscribeBtn.classList.add('disabled');
        }
      }));
  }
  if(subscribeEmail){
      subscribeEmail.addEventListener('change', (event => {
        event.preventDefault();
        if(isValidEmail(event.target.value)){
          mainUI.subscribeBtn.classList.remove('disabled');
        }
        else{
          mainUI.subscribeBtn.classList.add('disabled');
        }
      }));
  }
  let previoussubscribeEmailValue = subscribeEmail.value
  if(subscribeEmail){
    subscribeEmail.addEventListener('input', (event => {
        event.preventDefault();
        if(event.target.value!==previoussubscribeEmailValue){
            if (isValidEmail(event.target.value)) {
                mainUI.subscribeBtn.classList.remove("disabled");
            } else {
                mainUI.subscribeBtn.classList.add("disabled");
            }
        }
        }));
    }
  if(mainUI.subscribeBtn){
      mainUI.subscribeBtn.addEventListener('click', (event => {
        event.preventDefault();
        mainUI.subscribeBtn.value = '···';
        let email = subscribeEmail.value;
        let styles = ['men', 'women', 'unisex'];
        setCookie('style', 'all');
        subscribeToEmails(email, styles, this);
        setTimeout(function(){
          subscribeEmail.value = '';
          mainUI.subscribeBtn.value = 'Subscribe';
          mainUI.subscribeError.style.display = 'none';
        }, 2000);
      }));
  }
  let styleSelectorModal = UI.find('#subscribeFormModal select.styles');
  let subscribeEmailModal = UI.find('#subscribeFormModal input[type="email"]');
  if(subscribeEmailModal){
    subscribeEmailModal.addEventListener('keyup', (event => {
        event.preventDefault();
        if(isValidEmail(event.target.value)){
          mainUI.subscribeBtnModal.classList.remove('disabled');
        }
        else{
          mainUI.subscribeBtnModal.classList.add('disabled');
        }
      }));
  }
  if(subscribeEmailModal){
    subscribeEmailModal.addEventListener('change', (event => {
        event.preventDefault();
        if(isValidEmail(event.target.value)){
          mainUI.subscribeBtnModal.classList.remove('disabled');
        }
        else{
          mainUI.subscribeBtnModal.classList.add('disabled');
        }
      }));
  }
  let previoussubscribeEmailModalValue = subscribeEmailModal.value
  if(subscribeEmailModal){
    subscribeEmailModal.addEventListener('input', (event => {
        event.preventDefault();
        if(event.target.value!==previoussubscribeEmailModalValue){
            if (isValidEmail(event.target.value)) {
                mainUI.subscribeBtnModal.classList.remove("disabled");
            } else {
                mainUI.subscribeBtnModal.classList.add("disabled");
            }
        }
        }));
    }
  if(mainUI.subscribeBtnModal){
    mainUI.subscribeBtnModal.addEventListener('click', (event => {
        event.preventDefault();
        mainUI.subscribeBtnModal.value = '···';
        let email = subscribeEmailModal.value;
        let styles = ['men', 'women', 'unisex'];
        setCookie('style', 'all');
        subscribeToEmailsModal(email, styles, this);
        setTimeout(function(){
          subscribeEmailModal.value = '';
          mainUI.subscribeBtnModal.value = 'Subscribe';
          mainUI.subscribeErrorModal.style.display = 'none';
          UI.hideModals();
        }, 2000);
      }));
  }
  var jumppToSubscribeLinksWomen = document.querySelectorAll('a.jump-to-subscribe-women');
  if(jumppToSubscribeLinksWomen){
    for (const link of jumppToSubscribeLinksWomen){
        link.addEventListener('click', function(event){
        event.preventDefault()
        showSubscribeFormWomen();
      });
    }
  }
  var jumppToSubscribeLinks = document.querySelectorAll('a.jump-to-subscribe');
  if(jumppToSubscribeLinks){
    for (const link of jumppToSubscribeLinks){
        link.addEventListener('click', function(event){
        showSubscribeForm();
      });
    }
  }
  var showNavigationLinks = document.querySelectorAll('a.show-navigation');
  if(showNavigationLinks){
    for (const link of showNavigationLinks){
        link.addEventListener('click', function(event){
        event.preventDefault();
        showPrimaryNav();
        showDropdownMenu();
      });
    }
  }
  
  // GDPR Accept Button
  let agreeBtn = UI.find('a#agree');
  if(agreeBtn){
    agreeBtn.addEventListener('click', function(event){
      event.preventDefault();
      setCookie('gdpr', 'agreed');
      mainUI.body.classList.remove('gdpr-visible');
    });
  }
  
  //Disable Nav Items that are coming soon
  var disabledNavItems = document.querySelectorAll('#productMenu .product-block.disabled');
  if(disabledNavItems){
    for (const disabledNavItem of disabledNavItems){
      disabledNavItem.addEventListener('click', function(event){
        event.preventDefault();
        let flasher = disabledNavItem.querySelector('.flasher');
        if(flasher){
          flasher.classList.add('jiggle');
          setTimeout(function(){
            flasher.classList.remove('jiggle');
          }, 1000);
        }
      });
    }
  }
  
  //Close Modal
  var modalCloseBtns = document.querySelectorAll('.modal a.close-button');
  if(modalCloseBtns){
    for (const closeBtn of modalCloseBtns){
      closeBtn.addEventListener('click', function(event){
        event.preventDefault();
        UI.hideModals();
      });
    }
  }
  var modalActionBtns = document.querySelectorAll('.modal a.modal-button');
  if(modalActionBtns){
    for (const actionBtn of modalActionBtns){
      actionBtn.addEventListener('click', function(event){
        event.preventDefault();
        UI.hideModals();
      });
    }
  }

  // sidebar, style/gender selector
  let menTabLink = UI.find("#tab-link-men");
  if (menTabLink) {
    menTabLink.addEventListener("click", function(event) {
      event.preventDefault();
      changeNavTabLink("men");
      setCookie("style", "men");
      setCookie("nav-state", "men");
    })
  }
  let womenTabLink = UI.find("#tab-link-women");
  if (womenTabLink) {
    womenTabLink.addEventListener("click", function(event) {
      event.preventDefault();
      changeNavTabLink("women");
      setCookie("style", "women");
      setCookie("nav-state", "women");
    })
  }
  let fomTabLink = UI.find("#tab-link-fom");
  if (fomTabLink) {
    fomTabLink.addEventListener("click", function(event) {
      event.preventDefault();
      changeNavTabLink("fom");
      setCookie("nav-state", "fom");
    })
  }

  if(mainUI.joinFomForm){
    mainUI.joinFomForm.addEventListener('submit', (e) => {
      e.preventDefault();
      joinFomRequest();
    });
  }
  
  let websiteForms = UI.findAll('.website-form');

  if(websiteForms) {
    for (const websiteForm of websiteForms) {

      let submitButton = websiteForm.querySelector('#formSubmitBtn');
      let submitBtnVal = submitButton.value;

      //Form Specific Events
      if ( websiteForm.id == 'internationalRequests' ) {
        var countrySel = websiteForm.querySelector('#customer_country');
        var countryError = countrySel.closest('fieldset').querySelector('.error-message');
        var countryErrorMessage = countryError.querySelector('p');
        countrySel.addEventListener('change', (e) => {
          var value = countrySel.options[countrySel.selectedIndex].value;
          // Show message for India
          value == "India" ? countryError.style.display = 'block': countryError.style.display = 'none';
        });
      }
      //Website Submit Event
      websiteForm.addEventListener('submit', (e) => {
        e.preventDefault();
        submitButton.disabled = true;
        submitButton.value = "···";
        websiteFormRequest(websiteForm, submitBtnVal);
      });

    }
  }
  
  let productInfoExtended = UI.find('.product-variant #details .legal-info .toggle-info');
  let productInfoBtn = UI.find('.product-variant #details .legal-info .toggle');
  let mainInfo = UI.find('.product-variant #details .legal-info .main-info');
  let supplierInfo = UI.find('.product-variant #details .legal-info .supplier-info');
  if (productInfoBtn) {
    productInfoBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (productInfoExtended.classList.contains('hidden')) {
        productInfoExtended.classList.remove('hidden');
        setTimeout(function(){
          mainInfo.classList.remove('out-of-sight');
          supplierInfo.classList.remove('out-of-sight');
        }, 200);
      } else {
        productInfoExtended.classList.add('hidden');
        mainInfo.classList.add('out-of-sight');
        supplierInfo.classList.add('out-of-sight');
      }
    })
  }
}

  window.addEventListener('scroll', function () { //Scroll Events
    stickPrimaryNav();
  });

  window.addEventListener('DOMContentLoaded', function () { //OnLoad Events
  
  collectionNavLayout();
  washedRipples();
    
  if( mainUI.body.classList.contains('product-variant') && UI.find('#supply-shop') ) {
    //featureReveal();
  }
  
  if (UI.find("body").classList.contains('product-page') || UI.find("body").classList.contains('product-index') ){
    let style = ['men', 'women'].includes(getCookie('style')) ? getCookie('style') : 'men';
    if (typeof(seller) != 'undefined' && seller == 'gb'){
      style = 'men';
    }
    UI.find("body").classList.add(style);
  }

  if (UI.findAll('.tab-link')) {
    resetNavTabLink();
    let navState = ['men', 'women', 'fom'].includes(getCookie('nav-state')) ? getCookie('nav-state') : 'men';
    if (navState === 'women') {
      changeNavTabLink("women");
    } else if (navState === 'fom') {
      changeNavTabLink("fom");
    }
    else {
      changeNavTabLink("men");
    }
  }
  
  if (mainUI.body.classList.contains('product-index') && UI.find('#exclusives')) {
    initRellax();
  }
  
  if (mainUI.body.classList.contains('product-index') && UI.find('#classics')) {
    initRellax();
  }
  
  if (UI.find('#about')) {
    initRellax();
  }
    
  attachEventListeners();

  stickPrimaryNav();
  if (mainUI.body.classList.contains('product-page') && UI.find('#details') && UI.find('#details').length) {
    shopSlider();
  }
  if (mainUI.body.classList.contains('product-page') && UI.find('#stories') && UI.find('#stories').length) {
    storiesGrid();
  }
  
  if (mainUI.body.classList.contains('product-index') && UI.find('#exclusives-tease')) {
    UI.find('#exclusives-tease .picture').classList.add('fade-in');
    UI.find('#exclusives-tease h1').classList.add('fade-in-later');
    UI.find('#exclusives-tease .block-action').classList.add('fade-in-last');
  }
    
  if (mainUI.body.classList.contains('product-index') && UI.find('#back-to-tees')) {
    UI.find('#back-to-tees h1 #in').classList.add('fade-in');
    UI.find('#back-to-tees h1 #follow').classList.add('fade-in-last');
  }
    
  //Show GDPR Message
  var gdpr = getCookie('gdpr');
  if (gdpr != "agreed") {
    mainUI.body.classList.add('gdpr-visible')
  } else {
    mainUI.body.classList.remove('gdpr-visible')
  }

  // Hide Radio Size selector and Select Size selector on page load
  let radioSizePickerBlock = UI.find('div.radio-size-wrapper');
  if (radioSizePickerBlock){
    radioSizePickerBlock.style.display = 'none';
  }
  let selectSizePickerBlock = UI.find('div.select-size-wrapper');
  if (selectSizePickerBlock){
    selectSizePickerBlock.style.display = 'none';
  }

  if (document.querySelector("main#sale") ) {
    if (document.visibilityState == "visible") {
      realTimeCount();
    }
    setInterval(function(){
      if (document.visibilityState == "visible") {
        realTimeCount();
      }
    }, 20000)
  }
  
  let countryRequestPage = UI.find('#international-requests')
  if (countryRequestPage) {
    let countryDiv = UI.find('#countryName');
    setInterval( function(){
      countryDiv.innerHTML = getRandomCountry();
    }, 500)
  }

    function checkVideoAutoplayDisabled() {
      checkIOSPowerSavingMode().then((isPowerSavingMode) => {
        // isPowerSavingMode = true; // To test locally

        if (isPowerSavingMode) {
          if (mainUI.body.classList.contains('product-index') && UI.find('#suvin')) {
            UI.find('.suvin-branding-video').classList.add('fallback');
          }
          if (mainUI.body.classList.contains('product-variant') && UI.find('#suvin-tee')) {
            UI.find('.suvin-branding-video').classList.add('fallback');
          }
          const heavyTeaseComponent = UI.find('#heavy-tease .videoWrapper');
          if (heavyTeaseComponent){
            heavyTeaseComponent.classList.add('fallback');
          }
          // Commenting fallback for low power to avoid extra handlers
          // const coreNavVideoThumbnails = UI.findAll('.core-products .thumbnail')
          // if (coreNavVideoThumbnails.length > 0){
          //   coreNavVideoThumbnails.forEach(codeNavThumbnailVideo => {
          //       codeNavThumbnailVideo.classList.add('fallback');             
          //     });
          // }
          // const relatedProductBlocks = UI.findAll('.portrait')
          // if (relatedProductBlocks.length > 0){
          //   relatedProductBlocks.forEach(relatedProductBlock => {
          //       relatedProductBlock.classList.add('fallback');
          //   });
          // }
        }
      });
    }

  checkVideoAutoplayDisabled();

});
window.addEventListener('load', function () {
  setProgressBars();
}, false);
  
window.addEventListener('scroll', function () { //Scroll Events
});
